import React, { useContext } from 'react';
import Cross from '../../../../../Assets/Modals/closeIcon.svg';
import Excel from '../../../../../Assets/Modals/Excel.svg';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../../../Features/inventoryManagementSlice';
import { CSVContext } from '../../../../../Context/CSVContext';
import { v4 as uuidv4 } from 'uuid';

function DownloadCSV() {
    const dispatch = useDispatch();

    const { downloadUrl } = useContext(CSVContext);

    const handleCloseModal = () => {
        dispatch(closeModal());
    }

    const handleDownload = () => {
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = `${uuidv4()}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);

        handleCloseModal();
    }

    return (
        <div className='w-[27%] bg-[#FFFFFF] border border-[#EAEAEA] rounded-[9px] p-4 flex flex-col gap-6'>
            <div className="flex items-center gap-2 select-none">
                <div className="size-8 flex items-center justify-center">
                    <img src={Excel} alt="" />
                </div>

                <h1 className='font-bold text-2xl text-[#121212]'>Download your excel</h1>

                <button onClick={handleCloseModal} className="size-6 flex items-center justify-center ml-auto outline-none">
                    <img src={Cross} alt="" />
                </button>
            </div>

            <p className='font-medium text-base text-[#808080] select-none'>Download the excel file template to add your product details and upload the file later by selecting the Import option.</p>

            <button onClick={handleDownload} className='outline-none select-none w-fit rounded px-4 py-2 font-semibold text-base text-buttonText bg-primaryColor hover:bg-primaryAccent'>Download</button>
        </div>
    );
}

export default DownloadCSV;
